import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const GENETICMATERIALTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.GeneticMaterialType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.GeneticMaterialType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const GENETICMATERIALTYPE_CONFIG = {
  entityName: 'GeneticMaterialType',
  localizationKey: 'General::Entity.GeneticMaterialType',
  fields: GENETICMATERIALTYPE_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.GeneticMaterialTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
